import { toApiError } from "../../../types/api";

import type { ApiError } from "../../../types/api";

function asRecord(value: unknown): Record<string, unknown> {
  return typeof value === "object" && value !== null
    ? (value as Record<string, unknown>)
    : {};
}

export function toDictionaryAddError(error: unknown): ApiError {
  const normalized = toApiError(error);
  const record = asRecord(error);
  const payload = asRecord(record.payload);
  const reason = payload.error || normalized.message;
  let code = typeof record.code === "string" ? record.code : normalized.code;
  if (
    payload.code === "DICTIONARY_WORD_LIMIT_EXCEEDED" ||
    reason === "Dictionary word limit exceeded"
  ) {
    code = "DICTIONARY_WORD_LIMIT_EXCEEDED";
  } else if (
    payload.code === "TRANSLATION_UNAVAILABLE" ||
    reason === "Translation unavailable"
  ) {
    code = "TRANSLATION_UNAVAILABLE";
  } else if (
    payload.requiresRegistration === true ||
    reason === "Registration required"
  ) {
    code = "REGISTRATION_REQUIRED";
  } else if (reason === "Access denied to this text") {
    code = "TEXT_ACCESS_DENIED";
  } else if (
    reason === "Text not found" ||
    reason === "text_context_required"
  ) {
    code = "TEXT_NOT_FOUND";
  } else if (
    normalized.status === 401 ||
    reason === "Token expired" ||
    reason === "Invalid token" ||
    reason === "Invalid or expired token"
  ) {
    code = "SESSION_EXPIRED";
  } else if (normalized.status === 429) {
    code = "RATE_LIMITED";
  }
  return { ...normalized, code };
}

export function dictionaryAddErrorKey(error: unknown): string {
  const { code, status } = toDictionaryAddError(error);
  switch (code) {
    case "DICTIONARY_WORD_LIMIT_EXCEEDED":
      return "textWithDictionary.dictionaryLimitReached";
    case "TRANSLATION_UNAVAILABLE":
      return "textWithDictionary.errorTranslate";
    case "REGISTRATION_REQUIRED":
      return "textWithDictionary.registrationRequired";
    case "TEXT_ACCESS_DENIED":
      return "textWithDictionary.textAccessDenied";
    case "TEXT_NOT_FOUND":
      return "common:notifications.errors.textNotFound";
    case "SESSION_EXPIRED":
      return "common:notifications.errors.sessionExpired";
    case "RATE_LIMITED":
      return "common:errors.subscription.RATE_LIMIT_ERROR";
    default:
      return status === 404
        ? "common:notifications.errors.textNotFound"
        : "textWithDictionary.errorAddToDictionary";
  }
}
